<template>
  <div class="c-message elevation-2">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'c-message',
  props: {
    message: {
      type: [Number, String],
      default: ''
    }
  }
}
</script>

<style lang="scss">
  .c-message {
    position: fixed;
    top: 10px;
    left: 72px;
    padding: 10px 15px;
    border-radius: 5px;
    z-index: 1;
  }
</style>